export default __webpack_public_path__ + "static/media/img-02.3b6abc0f.png";